module.exports = __webpack_public_path__ + "img/olvido_clave.0a93533f.png";